import { request } from './repository';

const url = 'questionnaires/';

const questionnaireRepository = {
    actions: {
        updateQuestionnaire(id, data) {
            return request.put(url + id, data);
        },
        deleteQuestionnaire(id) {
            return request.delete(url + id);
        }
    }
}

export default questionnaireRepository;
